/* eslint-disable no-undef */
// project imports
import services from 'utils/mockAdapter';
// import { steam } from 'data/e-commerce';
import steam from 'data/steam.json';

// ==============================|| MOCK SERVICES ||============================== //

services.onGet('/api/steam/list').reply(200, { steam });

services.onPost('/api/steam/filter').reply((config) => {
  try {
    const { filter } = JSON.parse(config.data);

    if (filter.sort === 'high') {
      steam.sort((a, b) => Number(b.amount) - Number(a.amount));
    }

    if (filter.sort === 'low') {
      steam.sort((a, b) => Number(a.amount) - Number(b.amount));
    }

    // if (filter.sort === 'popularity') {
    //   steam.sort((a, b) => Number(b.popularity) - Number(a.popularity));
    // }

    // if (filter.sort === 'stock') {
    //   steam.sort((a, b) => Number(b.stock) - Number(a.stock));
    // }

    // if (filter.sort === 'new') {
    //   steam.sort((a, b) => Number(b.new) - Number(a.new));
    // }

    const results = steam.filter((steam) => {
      let searchMatches = true;

      if (filter.search) {
        const properties = ['name', 'fuel', 'unit', 'amount'];
        let containsQuery = false;

        properties.forEach((property) => {
          if (steam[property] && steam[property].toString().toLowerCase().includes(filter.search.toString().toLowerCase())) {
            containsQuery = true;
          }
        });

        if (!containsQuery) {
          searchMatches = false;
        }
      }

      // const genderMatches = filter.gender.length > 0 ? filter.gender.some((item) => item === steam.gender) : true;
      // const categoriesMatches =
      //   filter.categories.length > 0 && filter.categories.some((category) => category !== 'all')
      //     ? filter.categories.some((category) => steam.categories.some((item) => item === category))
      //     : true;
      // const colorsMatches = filter.colors.length > 0 ? filter.colors.some((color) => steam.colors.some((item) => item === color)) : true;

      // const minMax = filter.price ? filter.price.split('-') : '';
      // const priceMatches = filter.price ? steam.amount >= minMax[0] && steam.amount <= minMax[1] : true;
      // const ratingMatches = filter.rating > 0 ? steam.rating >= filter.rating : true;

      return searchMatches;
    });

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/steam/details').reply((config) => {
  try {
    const { id } = JSON.parse(config.data);

    let results;
    if (id === 'default') {
      [results] = steam;
    } else {
      // eslint-disable-next-line
      [results] = steam?.filter((steam) => steam.id === Number(id));
    }

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/steam/related').reply((config) => {
  try {
    const { id } = JSON.parse(config.data);

    const results = steam.filter((steam) => steam.id !== Number(id));

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/steam/list/single').reply((config) => {
  try {
    const result = steam.find((e) => e.id === Number(config.data));
    return [200, result];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/steam/insert').reply((config) => {
  try {
    let list = JSON.parse(config.data);
    list = {
      ...list,
      id: steam.length + 1
    };
    steam.push(list);
    return [200, { list }];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/steam/update').reply((config) => {
  try {
    const list = JSON.parse(config.data);

    let NewProduct = null;
    _.map(steam, (_list) => {
      if (_list.id === list.id) {
        _.assign(_list, { ...list });
        NewProduct = _list;
      }
      return _list;
    });

    return [200, { NewProduct }];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});
